export enum HelpCenterTypes {
  Video = 'video',
  Article = 'article'
}

export interface IHelpCenter {
  _id?: string;
  title: string;
  description: string;
  tags: Array<string>;
  type: HelpCenterTypes;
  active: boolean;
  mainVideo?: boolean;
  videoLink?: string;
}
